module.exports = __webpack_public_path__ + "static/img/culture1.15303ab5.jpg";